import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomesideuiComponent } from './home-side-ui.component';



@NgModule({
  declarations: [HomesideuiComponent],
  imports: [
    CommonModule
  ],
  exports :[
    HomesideuiComponent
  ]
})
export class HomesideuiModule { }
